'use strict';

require('../../style/index.less');

require('./index.less');

require('../../button/style');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/lib/modal/style/index.js
// module id = 219
// module chunks = 1